module.exports = __webpack_public_path__ + "img/myposition_wb_알폰소 데이비스.26c0ade4.png";